var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('v-chip',{staticClass:"ma-2",attrs:{"label":"","color":_vm.color},on:{"click":function($event){return _vm.onClick(_vm.item.PresentationID)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }